import { Button as MuiButton, Grid, InputBase } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import React from 'react';
import VerticalCenter from 'src/vertical-center/vertical-center';
import { styles } from './search-bar-styles';

interface ISearchBarProps {
  inputText: string;
  placeholder: string;
  hideCloseIcon: boolean;
  disabled?: boolean;
  onChange: (inputText: string) => void;
}

const SearchBar: React.FC<ISearchBarProps> = ({
  inputText,
  placeholder,
  hideCloseIcon,
  disabled,
  onChange,
}: ISearchBarProps): JSX.Element => {
  const classes = styles();

  const activeSearch: boolean = !!inputText.length;

  const onIconClick = (): void => {
    if (activeSearch && !hideCloseIcon) {
      onChange('');
    }
  };

  return (
    <Grid container className={classes.searchBarContainer}>
      <Grid item xs={11} className={`${classes.searchContainer} ${classes.searchLeft}`}>
        <VerticalCenter
          containerClass='fullWidth'
          itemClass='fullWidth'
          justifyContent='flex-start'
        >
          <Grid container className='fullWidth'>
            <Grid item className='flexFull'>
              <InputBase
                autoFocus={true}
                placeholder={placeholder}
                classes={{ root: classes.inputRoot, input: classes.input }}
                inputProps={{
                  'aria-label': 'search',
                  autoComplete: 'off',
                  className: 'global-keyboard',
                  'data-testid': 'search-input-text',
                  'data-custombuttons': 'keyboardWithSearchButton',
                  'data-customdisable-enter': disabled,
                }}
                value={inputText}
                onChange={(e): void => onChange(e.target.value)}
                name='searchTerm'
              />
            </Grid>
          </Grid>
        </VerticalCenter>
      </Grid>

      <Grid item xs={1} className={`${classes.searchContainer} ${classes.searchRight}`}>
        <VerticalCenter justifyContent='flex-end'>
          <SearchBarIcon
            activeSearch={activeSearch}
            onClick={onIconClick}
            disabled={disabled}
            hideCloseIcon={hideCloseIcon}
          />
        </VerticalCenter>
      </Grid>
    </Grid>
  );
};

export default SearchBar;

interface ISearchBarButton {
  activeSearch: boolean;
  hideCloseIcon: boolean;
  disabled?: boolean;
  onClick: () => void;
}

const SearchBarIcon = ({
  onClick,
  activeSearch,
  hideCloseIcon,
  disabled,
}: ISearchBarButton): JSX.Element => {
  const Icon = activeSearch && !hideCloseIcon ? CloseIcon : SearchIcon;

  return (
    <Grid item>
      <MuiButton
        variant='text'
        disabled={disabled}
        onClick={onClick}
        data-testid={`search-clear-summary`}
      >
        <Icon />
      </MuiButton>
    </Grid>
  );
};
